import React, { useState } from 'react';
import { X } from 'lucide-react';
import { COMMON_SUPPLEMENTS } from '../../../shared/constants';
import { FormSection } from '../../../shared/FormSection';
import { useUserData, UserDataType } from '@/context/UserDataContext';
import SearchableDropdown from '../../../shared/SearchableDropdown';

interface CurrentSupplementsInputProps {
  currentSupplements: string[];
  setUserData: React.Dispatch<React.SetStateAction<UserDataType>>;
  error?: string;
  onComplete?: () => void;
}

const CurrentSupplementsInput: React.FC<CurrentSupplementsInputProps> = ({ currentSupplements, setUserData, error }) => {
  const [inputValue, setInputValue] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleAddSupplement = (supplement: string) => {
    if (supplement.trim() && !currentSupplements.includes(supplement.trim())) {
      setUserData(prev => ({
        ...prev,
        currentSupplements: [...(prev.currentSupplements || []), supplement.trim()]
      }));
      setInputValue('');
    }
  };

  const handleRemoveSupplement = (supplement: string) => {
    setUserData(prev => ({
      ...prev,
      currentSupplements: (prev.currentSupplements || []).filter(s => s !== supplement)
    }));
  };

  return (
    <FormSection
      question="Current Supplements & Medications"
      helperText="Please list any supplements or medications you currently take. "
      error={error}
    >
      <div className="space-y-4">
        <SearchableDropdown
          inputValue={inputValue}
          setInputValue={setInputValue}
          onSelect={handleAddSupplement}
          categories={COMMON_SUPPLEMENTS}
          placeholder="Search or type to add..."
          isDropdownOpen={isDropdownOpen}
          setIsDropdownOpen={setIsDropdownOpen}
        />

        <div className="flex flex-wrap gap-2">
          {currentSupplements.map((supplement, index) => (
            <div 
              key={index}
              className="py-1.5 px-4 rounded-full flex items-center gap-2 bg-primary/5 text-sm"
            >
              <span>{supplement}</span>
              <button 
                type="button"
                onClick={() => handleRemoveSupplement(supplement)}
                className="text-muted-foreground/60 hover:text-foreground transition-colors"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </FormSection>
  );
};

export default CurrentSupplementsInput; 